// Import CSS
import './styles/main.scss'

// Import JS Modules
import ScrollColours from './scripts/ScrollColours'
import JcpProcess from './scripts/JcpProcess'
import MobileMenu from './scripts/MobileMenu'

const mobileMenu = new MobileMenu
const scrollColours = new ScrollColours
const jcpProcess = JcpProcess()

const ecoBlockContent = document.querySelectorAll('.eco-conscious-section__block.eco-conscious-section__block--content')
const ecoBlockPicture = document.querySelectorAll('.eco-conscious-section__block.eco-conscious-section__picture')

if (ecoBlockContent) {
    ecoBlockContent.forEach((block, index) => {
        let prefix = 'sm-order-'
        let adjustedIndex = index+2
        block.classList.add(`${prefix}${adjustedIndex}`)
    })
}

if (ecoBlockPicture) {
    ecoBlockPicture.forEach((block, index) => {
        let prefix = 'sm-order-'
        block.classList.add(`${prefix}${index+1}`)
    })
}

const homeTestimonialSlider = new Swiper('.block-testimonials-slider__slider .testimonials-slider', {
    slidesPerView: 1,
    speed: 850,
    spaceBetween: 100,
    loop: 'true',
    navigation: {
        nextEl: '.testimonials-slider .swiper-button-next',
    },
    pagination: {
        el: '.block-testimonials-slider__slider .swiper-pagination',
        type: 'bullets',
        clickable: true
    },
    simulateTouch: false,
    autoHeight: true,
    breakpoints: {
        639: {
          slidesPerView: 1,
          spaceBetween: 40
        },
        640: {
          slidesPerView: 1,
          spaceBetween: 100
        }
    }
})